import { SubItemViewModel } from './subItem.view-model';

export class PushSubItemViewModel extends SubItemViewModel {
    public advTracker: string;
    public code: string;
    public functionality: string;
    public zid: string;
    public zidMob: string;
    public zidSosh?: string;
    public zidSoshMob?: string;
    public textPrimary: boolean;

    public constructor(init?: Partial<PushSubItemViewModel>) {
        super(init);
        // Not recommended, used for retro-compatibility
        Object.assign(this, init);
    }
}
